import EventEmitter from 'events';
const authEvents = new EventEmitter();

const AuthUtility = {
	setAuthData: (first_name, last_name, email, token, role, app, paypal_email, paypal_merchant_id, password, remember_me) => {

		var first_name_initial = '';
		if (first_name && first_name !== '') {
			first_name_initial = ' ' + first_name.charAt(0);
		}

		var last_name_initial = '';
		if (last_name && last_name !== '') {
			last_name_initial = ' ' + last_name.charAt(0);
		}
		localStorage.setItem('auth_first_name', first_name);
		localStorage.setItem('auth_last_name', last_name);
		localStorage.setItem('auth_name', first_name_initial + last_name_initial);
		localStorage.setItem('auth_email', email);

		localStorage.setItem('auth_token', token);
		localStorage.setItem('auth_role', role);
		localStorage.setItem('auth_app', app);

		localStorage.setItem('auth_paypal_email', 'none');
		if (paypal_email && paypal_email != null && paypal_email !== '') {
			localStorage.setItem('auth_paypal_email', paypal_email);
		}

		localStorage.setItem('auth_paypal_merchant_id', 'none');
		if (paypal_merchant_id && paypal_merchant_id != null && paypal_merchant_id !== '') {
			localStorage.setItem('auth_paypal_merchant_id', paypal_merchant_id);
		}

		if (typeof remember_me === 'boolean') {
			if (remember_me) {
				localStorage.setItem('password', password);
				localStorage.setItem('remember_me', 'true');
			} else {
				localStorage.removeItem('password');
				localStorage.removeItem('remember_me');
			}
		}

		authEvents.emit('authChanged');
	},
	clearAuthData: () => {

		if (!localStorage.getItem('remember_me') || localStorage.getItem('remember_me') !== 'true') {
			localStorage.removeItem('auth_first_name');
			localStorage.removeItem('auth_last_name');
			localStorage.removeItem('auth_name');
			localStorage.removeItem('auth_email');
			localStorage.removeItem('password');
		}

		localStorage.removeItem('auth_token');
		localStorage.removeItem('auth_role');
		localStorage.removeItem('auth_app');

		localStorage.removeItem('auth_paypal_email');
		localStorage.removeItem('auth_paypal_merchant_id');

		AuthUtility.clearOrganizationData();

		authEvents.emit('authChanged');
	},
	getAuthData: () => {
		const first_name = localStorage.getItem('auth_first_name');
		const last_name = localStorage.getItem('auth_last_name');
		const name = localStorage.getItem('auth_name');
		const email = localStorage.getItem('auth_email');

		const token = localStorage.getItem('auth_token');
		const role = localStorage.getItem('auth_role');
		const app = localStorage.getItem('auth_app');

		const paypal_email = localStorage.getItem('auth_paypal_merchant_id');
		const paypal_merchant_id = localStorage.getItem('auth_paypal_merchant_id');

		return { first_name, last_name, name, email, token, role, app, paypal_email, paypal_merchant_id };
	},
	setUserData: (first_name, last_name, email) => {

		var last_name_initial = '';
		if (last_name && last_name !== '') {
			last_name_initial = ' ' + last_name.charAt(0);
		}
		localStorage.setItem('auth_first_name', first_name);
		localStorage.setItem('auth_last_name', last_name);
		localStorage.setItem('auth_name', first_name + last_name_initial);
		localStorage.setItem('auth_email', email);
	},
	setPasswordData: (password) => {

		var remember_me = false;
		if (localStorage.getItem('remember_me') && localStorage.getItem('remember_me') === 'true') {
			remember_me = true;
		}

		if (typeof remember_me === 'boolean') {
			if (remember_me) {
				localStorage.setItem('password', password);
				localStorage.setItem('remember_me', 'true');
			} else {
				localStorage.removeItem('password');
				localStorage.removeItem('remember_me');
			}
		}
	},
	setOrganizationData: (organization) => {
		if (organization && typeof organization === 'object') {
			localStorage.setItem('org_random_id', organization.random_id);
			localStorage.setItem('org_name', organization.name);
			localStorage.setItem('org_slug', organization.slug);
			localStorage.setItem('org_billing_contact', organization.billing_contact);
			localStorage.setItem('org_billing_email', organization.billing_email);
			localStorage.setItem('org_billing_address', organization.billing_address);
			localStorage.setItem('org_billing_city', organization.billing_city);
			localStorage.setItem('org_billing_state', organization.billing_state);
			localStorage.setItem('org_billing_zip', organization.billing_zip);
		} else {
			AuthUtility.clearOrganizationData();
		}
	},
	clearOrganizationData: () => {
		localStorage.removeItem('org_random_id');
		localStorage.removeItem('org_name');
		localStorage.removeItem('org_slug');
		localStorage.removeItem('org_billing_contact');
		localStorage.removeItem('org_billing_email');
		localStorage.removeItem('org_billing_address');
		localStorage.removeItem('org_billing_city');
		localStorage.removeItem('org_billing_state');
		localStorage.removeItem('org_billing_zip');
	},
	getOrganizationData: () => {
		const random_id = localStorage.getItem('org_random_id');
		const name = localStorage.getItem('org_name');
		const slug = localStorage.getItem('org_slug');
		const billing_contact = localStorage.getItem('org_billing_contact');
		const billing_email = localStorage.getItem('org_billing_email');
		const billing_address = localStorage.getItem('org_billing_address');
		const billing_city = localStorage.getItem('org_billing_city');
		const billing_state = localStorage.getItem('org_billing_state');
		const billing_zip = localStorage.getItem('org_billing_zip');

		return { random_id, name, name, slug, billing_contact, billing_email, billing_address, billing_city, billing_state, billing_zip };
	},
	isLoggedIn: () => {
		if (localStorage.getItem('auth_first_name') && localStorage.getItem('auth_last_name') && localStorage.getItem('auth_email')
			&& localStorage.getItem('auth_token') && localStorage.getItem('auth_role') && localStorage.getItem('auth_app')) {
			return true;
		} else {
			return false;
		}
	},
	onAuthChange: (callback) => authEvents.on('authChanged', callback),
	offAuthChange: (callback) => authEvents.off('authChanged', callback),
};

export default AuthUtility;
